/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ShortcutsEditHomeIcon = createIcon("ShortcutsEditHomeIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M79.5.5H.5v79h79V.5Z",
    fill: "#E1F4FF",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 28.5h-63a1 1 0 00-1 1v23a1 1 0 001 1h63a1 1 0 001-1v-23a1 1 0 00-1-1Z",
    fill: "#F3F3F3",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 41a4 4 0 10-8 0 4 4 0 008 0Zm14 0a4 4 0 10-8 0 4 4 0 008 0Zm14 0a4 4 0 10-8 0 4 4 0 008 0Zm14 0a4 4 0 10-8 0 4 4 0 008 0Z",
    fill: "#C8C8C8"
  }));
}, {});